import React, { useState } from "react";
import Box from "react-raster";
import { Checkbox, Heading } from "src/components";
import { theme } from "src/config";
import { Colors } from "src/types";

export const CheckboxSection = () => {
  const [checkbox1Checked, setCheckbox1Checked] = useState(false);

  return (
    <Box gridRowGap={theme.layout.gutterSmall}>
      <Heading weight="normal" type="h3" color="black">
        Checkbox
      </Heading>
      <Box>
        <hr />
      </Box>
      <Checkbox
        checked={checkbox1Checked}
        disabled={false}
        label="Checkbox"
        onCheckedChange={() => setCheckbox1Checked(!checkbox1Checked)}
      />
      <Checkbox
        checked={true}
        disabled={true}
        label="Disabled active"
        position="right"
      />
      <Checkbox
        checked={false}
        disabled={true}
        label="Disabled inactive"
        position="left"
      />
    </Box>
  );
};
